export const resolvedVisualVersion = (
  visualVersion: number | null | undefined,
): 1 | 2 => (visualVersion === 1 ? 1 : 2);
